<template>
  <div v-editable="blok">
    <b-form-group :label="blok.label">
      <FormInput
        :autofocus="true"
        :required="blok.required"
        name="firstname"
        autocomplete="given-name"
        placeholder="e.g. Jack"
        v-model="first_name"
      ></FormInput>
      <FormInput
        v-if="blok.show_surname"
        :required="blok.required"
        name="lastname"
        autocomplete="lname family-name"
        placeholder="e.g. Smith"
        v-model="last_name"
      ></FormInput>
    </b-form-group>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import FormInput from "@/components/form/FormInput";

export default {
  name: "profile-name",
  props: {
    blok: Object
  },
  components: {
        FormInput
    },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    first_name: {
      get: function() {
        return this.user.first_name;
      },
      set: function(value) {
        this.updateName({ first_name: value, last_name: this.last_name });
      }
    },
    last_name: {
      get: function() {
        return this.user.last_name;
      },
      set: function(value) {
        this.updateName({ first_name: this.first_name, last_name: value });
      }
    }
  },
  methods: {
    ...mapActions("profile", ["updateName"])
  }
};
</script>